<ces-asset-breadcrumb [trail]="breadcrumbTrail()" />
<div aria-live="polite" aria-atomic="true" class="sr-only">{{ liveRegionMessage() }}</div>

<div class="px-(--space-4)">
  <div class="mb-(--space-6) flex justify-between items-start">
    <div>
      <h1 class="text-[var(--text-xl)] font-semibold mb-(--space-2)">{{ graphName() }}</h1>
      <div class="flex items-center gap-(--space-3) mb-(--space-3)">
        <p-tag [value]="graphTypeLabel()" [rounded]="true" />
      </div>
      @if (graphDescription(); as description) {
        <ces-expandable-description [description]="description" />
      }
    </div>

    <div class="flex items-center gap-(--space-3)">
      @if (showDateNavigation()) {
        <ces-date-navigation
          [startDate]="dateNav().startDate()"
          [endDate]="dateNav().endDate()"
          [canNavigate]="dateNav().canNavigate()"
          [endDateDisabled]="dateNav().endDateDisabled()"
          [refreshDisabled]="!canRefresh()"
          (startDateChange)="dateNav().startDate.set($event)"
          (endDateChange)="dateNav().endDate.set($event)"
          (navigatePrevious)="dateNav().navigatePrevious()"
          (navigateNext)="dateNav().navigateNext()"
          (refresh)="refresh.emit()">
          @if (showRefreshControls()) {
            <div class="flex items-center gap-(--space-2)">
              <p-checkbox
                [binary]="true"
                [ngModel]="autoRefresh()"
                (ngModelChange)="autoRefreshChange.emit($event)"
                inputId="auto-refresh" />
              <label for="auto-refresh" class="cursor-pointer text-sm whitespace-nowrap">{{
                'common.labels.autoRefresh' | transloco
              }}</label>
            </div>
          }
        </ces-date-navigation>
      } @else if (showRefreshControls()) {
        <div class="flex items-center gap-(--space-2)">
          <p-checkbox
            [binary]="true"
            [ngModel]="autoRefresh()"
            (ngModelChange)="autoRefreshChange.emit($event)"
            inputId="auto-refresh" />
          <label for="auto-refresh" class="cursor-pointer text-sm whitespace-nowrap">{{
            'common.labels.autoRefresh' | transloco
          }}</label>
        </div>
        <ces-button-secondary
          [label]="'common.buttons.refresh' | transloco"
          icon="refresh"
          [disabled]="!canRefresh()"
          (onClick)="refresh.emit()" />
      }
      <ces-button
        [hasPermission]="{ method: 'putGraphicDetailResource', assetId: assetId() }"
        [label]="'common.buttons.save' | transloco"
        [disabled]="!canSave()"
        (onClick)="save.emit()" />
      @if (menuItems().length > 0) {
        <ces-action-menu [hasPermission]="{ method: 'getGraphicDetailResource', assetId: assetId() }" [menuItems]="menuItems()" />
      }
    </div>
  </div>
</div>
